<template>
  <b-card
    :id="`branch-${branch.id}`"
    class="rounded-5 h-100"
  >
    <b-dropdown
      v-if="isSmallScreen && currentBreakPoint !== 'md'"
      id="dropdown-1"
      toggle-class="my-custom-toggle"
      size="sm"
      right
      no-caret
      variant="outline-none"
      class="z-top"
    >
      <template #button-content>
        <feather-icon
          icon="MoreVerticalIcon"
          size="18"
          color="#000"
        />
      </template>
      <b-dropdown-item
        :to="{
          name: 'editBranch',
          params: {
            supplierId: this.$route.params.supplierId,
            branchId: this.$route.params.branchId,
          },
        }"
        variant="primary"
      >
        {{ $t('edit') }}
      </b-dropdown-item>
      <b-dropdown-item
        :to="{
          name: 'shippings',
          params: {
            branchId: this.$route.params.branchId,
          },
        }"
        variant="primary"
      >
        {{ $t('shippings') }}
      </b-dropdown-item>
      <b-dropdown-item
        variant="primary"
        :to="{
          name: 'supplierProductsCatalogs',
          params: { id: branch.id, type: 'sucursal' },
        }"
      >
        {{ $t('ProductCatalogs') }}
      </b-dropdown-item>
      <b-dropdown-item
        v-if="
          currentUser.role_name === 'admin' ||
            currentUser.role_name === 'supplier_admin'
        "
        variant="outline-primary"
        :to="{ name: 'supplierQuotes', params: { id: branch.id } }"
      >
        {{ $t('biddings') }}
      </b-dropdown-item>
    </b-dropdown>
    <b-row class="align-items-center">
      <b-col>
        <div class="branch-left">
          <b-img
            class="branch-logo"
            fluid
            width="70px"
            :src="require('@/assets/images/logo/logo.png')"
          />

          <div class="branch-content">
            <!-- Row 1: título -->
            <div class="branch-title-row">
              <h3 class="branch-title">
                {{ providerName }} {{ $t('branch') }} {{ branch.name }}
              </h3>
            </div>

            <!-- Row 2: controles (wrap) -->
            <div class="branch-controls-row">
              <div class="branch-control-group">
                <span class="text-muted mr-1">{{ $t('deliveryTime') }}</span>

                <b-overlay :show="expressLoading">
                  <b-form-radio-group
                    id="btn-radios-1"
                    :checked="branch.is_express"
                    size="sm"
                    name="radios-btn-default"
                    buttons
                    class="mr-2"
                    @change="changeExpressStatus"
                  >
                    <b-form-radio
                      button-variant="outline-primary"
                      :value="true"
                    >
                      {{ $t('express') }}
                    </b-form-radio>
                    <b-form-radio
                      button-variant="outline-secondary"
                      :value="false"
                    >
                      Normal
                    </b-form-radio>
                  </b-form-radio-group>
                </b-overlay>
              </div>

              <div class="branch-control-group delivery-hours">
                <span class="text-muted mr-1">Hrs:</span>

                <b-overlay :show="deliveryLoading">
                  <!-- Modo lectura -->
                  <div
                    v-if="!isEditingDeliveryTime"
                    class="d-flex align-items-center"
                  >
                    <span class="text-muted">
                      {{ formatHours(branch.delivery_time_hours) }} hrs
                    </span>

                    <b-button
                      v-if="canEditDeliveryTime"
                      size="sm"
                      variant="link"
                      class="p-0 ml-1 edit-icon-btn"
                      @click="startEditDeliveryTime"
                    >
                      <feather-icon
                        icon="Edit2Icon"
                        size="14"
                      />
                    </b-button>
                  </div>

                  <!-- Modo edición -->
                  <b-input-group
                    v-else
                    size="sm"
                    class="hrs-input"
                  >
                    <b-form-input
                      v-model="deliveryTimeHoursLocal"
                      type="number"
                      min="0"
                      step="0.01"
                      @keyup.enter="saveDeliveryTimeHours"
                      @keyup.esc="cancelEditDeliveryTime"
                    />
                    <b-input-group-append>
                      <b-button
                        variant="outline-primary"
                        :disabled="deliveryLoading"
                        @click="saveDeliveryTimeHours"
                      >
                        <feather-icon
                          icon="CheckIcon"
                          size="14"
                          class="mr-25"
                        />
                        Guardar
                      </b-button>
                      <b-button
                        variant="outline-secondary"
                        :disabled="deliveryLoading"
                        @click="cancelEditDeliveryTime"
                      >
                        <feather-icon
                          icon="XIcon"
                          size="14"
                          class="mr-25"
                        />
                        Cancelar
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-overlay>
              </div>
            </div>

            <!-- Row 3: acciones -->
            <div
              v-if="!isSmallScreen || currentBreakPoint === 'md'"
              class="branch-actions-row"
            >
              <b-button
                size="sm"
                class="mr-1"
                variant="primary"
                :to="{
                  name: 'editBranch',
                  params: { supplierId: $route.params.supplierId, branchId: $route.params.branchId }
                }"
              >
                {{ $t('edit') }}
              </b-button>

              <b-button
                size="sm"
                class="mr-1"
                variant="primary"
                :to="{ name: 'shippings', params: { branchId: $route.params.branchId } }"
              >
                {{ $t('shippings') }}
              </b-button>

              <b-button
                size="sm"
                class="mr-1"
                variant="primary"
                :to="{ name: 'supplierProductsCatalogs', params: { id: branch.id, type: 'sucursal' } }"
              >
                {{ $t('ProductCatalogs') }}
              </b-button>

              <b-button
                v-if="currentUser.role_name === 'admin' || currentUser.role_name === 'supplier_admin'"
                size="sm"
                variant="outline-primary"
                :to="{ name: 'supplierQuotes', params: { id: branch.id } }"
              >
                {{ $t('biddings') }}
              </b-button>
            </div>
          </div>
        </div>
      </b-col>
      <b-col
        md="auto"
        class="mt-1 mt-lg-0"
      >
        <b-row>
          <b-col sm="auto">
            <div class="d-flex align-items-center">
              <feather-icon
                size="16"
                class="mr-1"
                icon="UserIcon"
              />
            </div>
          </b-col>
          <b-col>
            {{ branch.contact_name }}
            <!-- {{ branch.contact_name }} -->
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="auto">
            <div class="d-flex align-items-center">
              <feather-icon
                size="16"
                class="mr-1"
                icon="AtSignIcon"
              />
            </div>
          </b-col>
          <b-col>
            {{ branch.email }}
            <!-- {{ branch.email }} -->
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="auto">
            <div class="d-flex align-items-center">
              <feather-icon
                size="16"
                class="mr-1"
                icon="TruckIcon"
              />
            </div>
          </b-col>
          <b-col>
            {{ branch.logistic_name }}
            <!-- {{ $t(branch.active_status ? 'active' : 'unactive') }} -->
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="auto">
            <div class="d-flex align-items-center">
              <feather-icon
                size="16"
                class="mr-1"
                icon="PhoneIcon"
              />
            </div>
          </b-col>
          <b-col>
            {{ branch.phone }}
            <!-- Representante de Sucursal -->
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'

export default {
  components: {},

  props: {
    branch: {
      type: Object,
      default: () => {},
    },
    providerName: {
      type: String,
      default() {
        return ''
      },
    },
  },
  data() {
    return {
      expressLoading: false,
      deliveryLoading: false,
      deliveryTimeHoursLocal: null,
      isEditingDeliveryTime: false,
    }
  },
  computed: {
    ...mapState('auth', ['currentUser']),
    ...mapGetters('app', ['currentBreakPoint', 'isSmallScreen']),
    canEditDeliveryTime() {
      return this.currentUser?.role_name === 'admin'
    },
  },
  watch: {
    // para que al cargar branch o al refrescar, se actualice el input
    branch: {
      immediate: true,
      deep: true,
      handler(val) {
        this.deliveryTimeHoursLocal = val?.delivery_time_hours ?? null
      },
    },
  },
  mounted() {},
  methods: {
    ...mapActions('branches', ['setBranchExpress', 'updateBranchDeliveryTimeHours']),

    formatHours(val) {
      if (val === null || val === undefined || val === '') return '--'
      const n = Number(val)
      if (Number.isNaN(n)) return '--'
      return n.toFixed(2)
    },

    async changeExpressStatus(value) {
      try {
        this.expressLoading = true
        await this.setBranchExpress({
          supplierId: this.$route.params.supplierId,
          branchId: this.$route.params.branchId,
          is_express: value,
        })
      } finally {
        this.expressLoading = false
      }
    },

    async saveDeliveryTimeHours() {
      if (!this.canEditDeliveryTime) return

      const n = Number(this.deliveryTimeHoursLocal)
      if (Number.isNaN(n) || n < 0) {
        this.deliveryTimeHoursLocal = this.branch?.delivery_time_hours ?? null
        return
      }

      const current = Number(this.branch?.delivery_time_hours)
      if (!Number.isNaN(current) && Number(current.toFixed(2)) === Number(n.toFixed(2))) {
        this.isEditingDeliveryTime = false
        return
      }

      try {
        this.deliveryLoading = true
        await this.updateBranchDeliveryTimeHours({
          supplierId: this.$route.params.supplierId,
          branchId: this.$route.params.branchId,
          delivery_time_hours: Number(n.toFixed(2)),
        })
        this.isEditingDeliveryTime = false
      } finally {
        this.deliveryLoading = false
      }
    },

    startEditDeliveryTime() {
      if (!this.canEditDeliveryTime) return
      this.deliveryTimeHoursLocal = this.branch?.delivery_time_hours ?? null
      this.isEditingDeliveryTime = true
    },

    cancelEditDeliveryTime() {
      this.deliveryTimeHoursLocal = this.branch?.delivery_time_hours ?? null
      this.isEditingDeliveryTime = false
    },

  },
}
</script>

<style lang="scss" scoped>
#dropdown-1 {
  position: absolute;
  top: 0;
  right: 0;
}

.branch-left {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.branch-logo {
  flex: 0 0 auto;
}

.branch-content {
  min-width: 0; // clave para evitar overflow de textos largos
  flex: 1 1 auto;
}

.branch-title-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.branch-title {
  margin: 0;
  font-weight: 800;
  line-height: 1.2;
  font-size: 1.2rem;
  // no rompe todo si el nombre es largo
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.branch-controls-row {
  margin-top: 6px;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap; // <-- el fix principal
}

.branch-control-group {
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 0 0 auto;
}

.branch-email {
  flex: 1 1 auto;
  min-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.branch-actions-row {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

/* Responsive: en pantallas chicas el título baja, controles a columna */
@media (max-width: 992px) {
  .branch-title {
    white-space: normal;
  }
  .branch-email {
    min-width: 100%;
  }
}

@media (max-width: 576px) {
  .branch-left {
    align-items: flex-start;
  }
  .hrs-input {
    width: 100%;
    max-width: 240px;
  }
}
.delivery-hours {
  max-width: 420px;
}

.edit-icon-btn {
  color: #6c757d; // muted
  line-height: 1;
}
.edit-icon-btn:hover {
  color: #340668; // tu morado
  text-decoration: none;
}

.hrs-input {
  width: 320px; // input + 2 botones
}
@media (max-width: 576px) {
  .hrs-input {
    width: 100%;
    max-width: 360px;
  }
}

</style>
